import {isInstanceOf, isPlainObject} from 'rlink-type-utils';

/**
 * Returns true if the given key would be returned by the keys
 * iterator for that object.
 *
 * @param  {IterableCollection} obj
 * @param  {*} key
 * @return {Boolean}
 */
export default function hasKey (obj, key) {
  if (!this.isCollection(obj)) {
    throw new Error(`Cannot check key of non-collection object: ${obj}`);
  }
  if (isInstanceOf(obj, Array)) {
    if (!isInstanceOf(key, Number)) {
      throw new Error(`Array key must be a number! (got: ${key})`);
    }
    if (key < 0) {
      throw new Error(`Negative numbers are not valid array keys! (got: ${key})`);
    }
    return key < obj.length;
  } else if (obj && typeof obj.has === 'function') {
    return obj.has(key);
  } else if (isPlainObject(obj)) {
    return key in obj;
  } else {
    return this.NotApplicable;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/hasKey.js